import { render } from "./NcrmPrivacyPreferenceLinksDrawer.vue?vue&type=template&id=2b3e0790"
import script from "./NcrmPrivacyPreferenceLinksDrawer.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyPreferenceLinksDrawer.vue?vue&type=script&lang=js"

import "./NcrmPrivacyPreferenceLinksDrawer.vue?vue&type=style&index=0&id=2b3e0790&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__